// src/Calendly.js
import React from "react";

let calendlyLoading = null;

export function loadCalendly() {
  // Only in browser
  if (typeof window === "undefined") return Promise.resolve();
  if (window.Calendly) return Promise.resolve();
  if (calendlyLoading) return calendlyLoading;

  calendlyLoading = new Promise((resolve, reject) => {
    // If script tag is already there
    const existing = document.querySelector(
      'script[src*="assets/calendly.com/assets/external/widget.js"]'
    );
    if (existing) {
      if (window.Calendly) return resolve();
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", () =>
        reject(new Error("Calendly failed to load"))
      );
      return;
    }

    // Inject JS
    const s = document.createElement("script");
    s.src = "https://assets.calendly.com/assets/external/widget.js";
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("Calendly failed to load"));
    document.head.appendChild(s);

    // Inject CSS (non-blocking)
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = "https://assets.calendly.com/assets/external/widget.css";
    document.head.appendChild(l);
  });

  return calendlyLoading;
}

export async function openCalendly(url, prefill) {
  try {
    await loadCalendly();
    if (typeof window !== "undefined" && window.Calendly) {
      window.Calendly.initPopupWidget({ url, prefill });
    }
  } catch {
    // Swallow errors to avoid crashing the app
  }
}

export function InlineCalendly({ url, style }) {
  // Guard for SSR / build
  if (typeof window === "undefined") return null;
  loadCalendly().catch(() => {});
  const merged = { minWidth: "320px", height: "720px", width: "100%", ...style };
  return <div className="calendly-inline-widget" data-url={url} style={merged} />;
}
